import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./ConsultProcess.css";

const ConsultProcess = () => {
  return (
    <>
      <div className="container consult-process-section mb-5">
        <div className="row px-xxl-5 px-md-3 px-2">
          <div className="col-md-12">
            <h1 className="text-center headings">
              <span>Our</span> Consultation Process
            </h1>

            <div className="row mt-md-5 mt-4">
              <div className="col-md-4 ">
                <div className="process-box">
                  <h3 className="headings text-center border-bottom">STEP 1</h3>
                  <p className="subhead-process mb-2 mt-3 text-center">
                    Discover Your Needs
                  </p>
                  <p className="text-center  process-txt">
                    We begin by understanding your specific travel requirements,
                    business objectives, and personal preferences. Our team
                    customizes every detail to meet your corporate travel
                    demands.
                  </p>
                </div>
              </div>
              <div className="col-md-4 mt-4 mt-md-0 ">
                <div className="process-box">
                  <h3 className="headings text-center border-bottom">STEP 2</h3>
                  <p className="subhead-process mb-2 mt-3 text-center">
                    {" "}
                    Crafting Your Perfect Plan
                  </p>
                  <p className="text-center  process-txt">
                    Using our expertise, we create a customized travel program
                    that perfectly fits your budget. From detailed itineraries
                    to perfect accommodations, we ensure a luxurious travel
                    experience.
                  </p>
                </div>
              </div>
              <div className="col-md-4   mt-4 mt-md-0 ">
                <div className="process-box">
                  <h3 className="headings text-center border-bottom">STEP 3</h3>
                  <p className="subhead-process mb-2 mt-3 text-center">
                    Continuous Optimization & Support
                  </p>
                  <p className="text-center  process-txt">
                    {" "}
                    We optimize costs while maintaining safety and compliance.
                    Our team provides continuous 24/7 support and gathers
                    feedback to continuously improve future travel.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsultProcess;
